export default __webpack_public_path__ + "static/media/EAST1040.34I-34096_-18303_0.24de5e97.jpg";